module.exports = __webpack_public_path__ + "static/media/mihaela.3ce69c56.JPG";